import { useState, useEffect } from "react";

// Single shared <audio> for all preview buttons in the app, so starting one
// stops any other that's playing, and each button can toggle play/stop.
let current = null; // HTMLAudioElement
let currentUrl = null;
const listeners = new Set();
const notify = () => listeners.forEach(l => l(currentUrl));

const stop = () => {
  if (current) {
    try {
      current.pause();
    } catch (e) {
      /* ignore */
    }
    current = null;
  }
  if (currentUrl !== null) {
    currentUrl = null;
    notify();
  }
};

const toggle = url => {
  if (!url) return;
  // clicking the one that's playing -> stop
  if (currentUrl === url && current && !current.paused) {
    stop();
    return;
  }
  stop();
  current = new Audio(url);
  currentUrl = url;
  current.onended = () => {
    current = null;
    currentUrl = null;
    notify();
  };
  current.onerror = () => {
    current = null;
    currentUrl = null;
    notify();
  };
  current.play().catch(() => {
    current = null;
    currentUrl = null;
    notify();
  });
  notify();
};

export const audioPreview = { toggle, stop, get playingUrl() { return currentUrl; } };

// React hook: re-renders when the playing track changes.
export const useAudioPreview = () => {
  const [playingUrl, setPlayingUrl] = useState(currentUrl);
  useEffect(() => {
    listeners.add(setPlayingUrl);
    return () => listeners.delete(setPlayingUrl);
  }, []);
  return { playingUrl, toggle, stop };
};
